var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRenameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16634 19.2499L12.833 15.5833H20.1663V19.2499H9.16634ZM3.66634 17.4166H4.94967L12.8559 9.51034L11.5726 8.227L3.66634 16.1333V17.4166ZM16.7747 8.18117L12.8788 4.33117L14.1622 3.04784C14.5136 2.69645 14.9453 2.52075 15.4574 2.52075C15.9689 2.52075 16.4004 2.69645 16.7518 3.04784L18.0351 4.33117C18.3865 4.68256 18.5698 5.10667 18.5851 5.6035C18.6004 6.09972 18.4323 6.52353 18.0809 6.87492L16.7747 8.18117ZM15.4455 9.53325L5.72884 19.2499H1.83301V15.3541L11.5497 5.63742L15.4455 9.53325ZM12.2143 8.86867L11.5726 8.227L12.8559 9.51034L12.2143 8.86867Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenameIcon);
export default __webpack_public_path__ + "static/media/RenameIcon.6ebe7f52e91424719859b268f36b0153.svg";
export { ForwardRef as ReactComponent };